export const handleCustomInsertDropdown = (
  FroalaEditor,
  openLinkPopup,
  handleEmojiPickerClick,
  handleGIFPickerClick,
  openMediaPopup
) => {
  // Register command
  FroalaEditor.RegisterCommand("Insert", {
    title: "Insert",
    type: "dropdown",
    focus: false,
    undo: false,
    refreshAfterCallback: true,
    options: {
      embedVideo: "Embed Video",
      emoji: "Emoji",
      gif: "GIF",
      horizontalLine: "Horizontal Line",
      link: "Link",
      // specialChars: "Special Characters",
      uploadMedia: "Upload Media",
    },
    callback: function (cmd, val) {
      if (val === "embedVideo") {
        openLinkPopup();
      }
      if (val === "emoji") {
        handleEmojiPickerClick();
      }
      if (val === "gif") {
        handleGIFPickerClick();
      }
      if (val === "horizontalLine") {
        this.commands.insertHR();
      }
      if (val === "link") {
        this.link.showInsertPopup();
      }
      // if (val === "specialChars") {
      //   this.specialCharacters.showSpecialCharsPopup();
      // }
      if (val === "uploadMedia") {
        openMediaPopup();
      }
    },
    refresh: function ($btn) {
      console.log("do refresh");
    },
    refreshOnShow: function ($btn, $dropdown) {
      console.log("do refresh when show");
    },
  });
};

export const setSkeletonLoaderContentFroala = (
  editorRef,
  loaderId,
  content
) => {
  if (editorRef.current) {
    const current = editorRef.current?.html.get();
    console.log("Current HTML:", current); // Debug log
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(current, "text/html");
    const loaderElement = htmlDoc.getElementById(loaderId);
    console.log("Loader Element:", loaderElement); // Debug log

    const regexPattern = new RegExp(`<div id="${loaderId}".*?<\/div>`);

    if (loaderElement) {
      const newContent = current.replace(regexPattern, content);
      console.log("New Content:", newContent); // Debug log

      editorRef.current?.html?.set(newContent);
    }
  }
};

// export const handleCustomBoldIcon = (FroalaEditor) => {
//   FroalaEditor.DefineIconTemplate(
//     "svg_template",
//     '<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">[PATH]</svg>'
//   );

//   FroalaEditor.DefineIcon("bold", {
//     template: "svg_template",
//     PATH: '<path d="M8.1665 12H12.6633C14.3181 12 15.6633 10.6547 15.6633 9C15.6633 7.34526 14.3181 6 12.6633 6H9.42966C8.73492 6 8.1665 6.56842 8.1665 7.26316V12ZM8.1665 12H14.1665C15.8212 12 17.1665 13.3453 17.1665 15C17.1665 16.6547 15.8212 18 14.1665 18H9.42966C8.73492 18 8.1665 17.4316 8.1665 16.7368V12Z" stroke="#565556" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>',
//   });
// };

// export const handleCustomTextColor = (FroalaEditor) => {
//   FroalaEditor.DefineIconTemplate(
//     "svg_template",
//     '<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">[PATH]</svg>'
//   );

//   FroalaEditor.DefineIcon("textColor", {
//     template: "svg_template",
//     PATH: `<path d="M15.7914 18.2973C15.5202 18.2973 15.3368 18.1697 15.2411 17.9145C15.0816 17.4838 14.8902 17.0053 14.6668 16.4789C14.4435 15.9525 14.2043 15.4022 13.9491 14.828H7.20189C6.97858 15.4022 6.76325 15.9525 6.55589 16.4789C6.36448 16.9893 6.18902 17.4599 6.02951 17.8905C5.98166 18.0181 5.90191 18.1218 5.79025 18.2016C5.6786 18.2654 5.55896 18.2973 5.43136 18.2973C5.2878 18.2973 5.15222 18.2414 5.02461 18.1298C4.91296 18.0022 4.85713 17.8506 4.85713 17.6752C4.85713 17.6273 4.86511 17.5635 4.88106 17.4838C4.91296 17.3881 4.98474 17.2046 5.09639 16.9335C5.36756 16.2157 5.68657 15.3942 6.05344 14.4691C6.43626 13.5439 6.843 12.5789 7.27367 11.574C7.70434 10.5691 8.14299 9.55625 8.58961 8.53541C9.03623 7.51456 9.4669 6.54954 9.88162 5.64034C9.99328 5.40108 10.1847 5.28145 10.4558 5.28145H10.5516C10.8387 5.28145 11.0301 5.39311 11.1258 5.61642C11.5564 6.54156 12.011 7.53848 12.4896 8.60718C12.984 9.67589 13.4626 10.7366 13.9251 11.7894C14.3877 12.8262 14.8104 13.7992 15.1932 14.7083C15.576 15.6016 15.8871 16.3433 16.1263 16.9335C16.2539 17.2206 16.3257 17.412 16.3417 17.5077C16.3736 17.6034 16.3895 17.6672 16.3895 17.6991C16.3895 17.8586 16.3257 18.0022 16.1981 18.1298C16.0865 18.2414 15.9509 18.2973 15.7914 18.2973ZM13.4466 13.6317C12.984 12.563 12.4975 11.4703 11.9871 10.3538C11.4767 9.23724 10.9822 8.17651 10.5037 7.17162C10.0571 8.19246 9.58653 9.26117 9.09206 10.3777C8.61353 11.4783 8.15096 12.563 7.70434 13.6317H13.4466Z" fill="#565556"/>
// <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9758 18.0127C14.8181 17.587 14.6284 17.1126 14.4064 16.5894C14.2056 16.1161 13.9919 15.6233 13.7651 15.1109H7.39539C7.19723 15.6198 7.00542 16.1096 6.81997 16.5804C6.62899 17.0897 6.45395 17.5591 6.29482 17.9888C6.22708 18.1694 6.11177 18.3196 5.9547 18.4318L5.94305 18.4401L5.93062 18.4472C5.77657 18.5352 5.6086 18.5802 5.43136 18.5802C5.20723 18.5802 5.00764 18.4909 4.83832 18.3427L4.82412 18.3303L4.8117 18.3161C4.65323 18.135 4.57422 17.9166 4.57422 17.6752C4.57422 17.6002 4.58619 17.5155 4.60364 17.4283L4.60709 17.411L4.61266 17.3943C4.64797 17.2884 4.72295 17.0975 4.83321 16.8296C5.10473 16.111 5.42383 15.2893 5.79045 14.3648L5.79199 14.3609C6.1753 13.4346 6.58254 12.4685 7.01363 11.4626C7.44459 10.457 7.88352 9.44349 8.33042 8.42201C8.77756 7.39997 9.20883 6.4336 9.62422 5.52293L9.62524 5.5207C9.70018 5.36011 9.8095 5.22468 9.95898 5.13126C10.108 5.03814 10.278 4.99854 10.4559 4.99854H10.5516C10.7307 4.99854 10.903 5.03334 11.053 5.12082C11.2048 5.20938 11.3145 5.34084 11.384 5.50063C11.8146 6.42571 12.2689 7.42217 12.7471 8.48996C13.2419 9.5595 13.7208 10.6211 14.1838 11.6748C14.6468 12.7126 15.0701 13.6869 15.4536 14.5977C15.8357 15.4893 16.1469 16.2312 16.3868 16.8229C16.5029 17.0844 16.5877 17.2982 16.6162 17.4367C16.6307 17.4811 16.6429 17.5222 16.652 17.5587C16.661 17.5946 16.6724 17.6466 16.6724 17.6991C16.6724 17.9438 16.5712 18.1568 16.3982 18.3298C16.2329 18.4952 16.0251 18.5802 15.7914 18.5802C15.6106 18.5802 15.4373 18.5371 15.2889 18.4338C15.1405 18.3306 15.0393 18.1821 14.9758 18.0127ZM16.3417 17.5077C16.3257 17.412 16.2539 17.2206 16.1263 16.9335C15.8871 16.3433 15.576 15.6016 15.1932 14.7083C14.8104 13.7992 14.3877 12.8262 13.9251 11.7894C13.4626 10.7366 12.984 9.67589 12.4896 8.60718C12.011 7.53848 11.5564 6.54156 11.1258 5.61642C11.0301 5.39311 10.8387 5.28145 10.5516 5.28145H10.4558C10.1847 5.28145 9.99328 5.40108 9.88162 5.64034C9.4669 6.54954 9.03623 7.51456 8.58961 8.53541C8.14299 9.55625 7.70434 10.5691 7.27367 11.574C6.843 12.5789 6.43626 13.5439 6.05344 14.4691C5.68657 15.3942 5.36756 16.2157 5.09639 16.9335C4.98474 17.2046 4.91296 17.3881 4.88106 17.4838C4.86511 17.5635 4.85713 17.6273 4.85713 17.6752C4.85713 17.8506 4.91296 18.0022 5.02461 18.1298C5.15222 18.2414 5.2878 18.2973 5.43136 18.2973C5.55896 18.2973 5.6786 18.2654 5.79025 18.2016C5.90191 18.1218 5.98166 18.0181 6.02951 17.8905C6.18902 17.4599 6.36448 16.9893 6.55589 16.4789C6.76325 15.9525 6.97858 15.4022 7.20189 14.828H13.9491C14.2043 15.4022 14.4435 15.9525 14.6668 16.4789C14.8902 17.0053 15.0816 17.4838 15.2411 17.9145C15.3368 18.1697 15.5202 18.2973 15.7914 18.2973C15.9509 18.2973 16.0865 18.2414 16.1981 18.1298C16.3257 18.0022 16.3895 17.8586 16.3895 17.6991C16.3895 17.6672 16.3736 17.6034 16.3417 17.5077ZM13.0153 13.3488C12.6052 12.4081 12.1767 11.449 11.7298 10.4714C11.3139 9.5615 10.9086 8.68883 10.5139 7.8534C10.1422 8.70091 9.75464 9.58025 9.35113 10.4914C8.93167 11.4562 8.5245 12.4086 8.12962 13.3488H13.0153ZM13.3238 13.3488C13.365 13.4432 13.4059 13.5376 13.4466 13.6317H7.70434C7.7437 13.5375 7.78319 13.4432 7.8228 13.3488C8.23262 12.3717 8.65571 11.3813 9.09206 10.3777C9.53143 9.38558 9.95193 8.43121 10.3535 7.51464C10.4039 7.3997 10.4539 7.28536 10.5037 7.17162C10.5571 7.28371 10.6107 7.3965 10.6644 7.50998C11.0927 8.41385 11.5336 9.36179 11.9871 10.3538C12.4526 11.372 12.8982 12.3703 13.3238 13.3488Z" fill="#565556"/>
// <path d="M14.7616 12.4586L14.7615 12.4587C13.5896 14.3967 13.002 15.7985 12.9324 16.7003C12.8583 17.7351 13.3337 18.8131 14.122 19.4175L14.122 19.4174L14.1231 19.4182C14.7661 19.9166 15.3358 20.1094 16.1204 20.1094C17.0211 20.1094 17.6555 19.8494 18.2946 19.2157C19.1881 18.322 19.4958 17.0039 19.087 15.814C18.7233 14.7622 18.0927 13.4984 17.2296 12.1188L17.2294 12.1184C17.1081 11.9237 16.9813 11.7293 16.8747 11.5729C16.763 11.4091 16.6856 11.3052 16.6587 11.2764L16.6586 11.2764L16.6564 11.2739C16.4389 11.0355 16.101 10.9678 15.7677 11.1207C15.694 11.155 15.6485 11.1801 15.6065 11.2124C15.5646 11.2447 15.5168 11.2915 15.4506 11.3767C15.3124 11.5546 15.1225 11.861 14.7616 12.4586Z" fill="#E54D2E" stroke="white" stroke-width="0.5"/>
// `,
//   });
// };

export const handleAiAssistantIcon = (
  FroalaEditor,
  setShowAiPrompt,
  setEditorId = null
) => {
  FroalaEditor.DefineIconTemplate(
    "svg_template",
    '<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">[PATH]</svg>'
  );

  FroalaEditor.DefineIcon("aiAssistantIcon", {
    template: "svg_template",
    PATH: `<path d="M18.092 11.6413C18.092 11.3283 17.9163 11.0412 17.6367 10.8989C16.9209 10.5343 16.1544 10.1989 15.2955 9.87266C13.8756 9.32834 12.841 8.27798 12.3034 6.83895C11.9813 5.96587 11.65 5.18851 11.2913 4.46275C11.1506 4.17978 10.861 4 10.5456 4C10.2301 4 9.93882 4.17978 9.79983 4.46359C9.44194 5.18685 9.11152 5.96421 8.78943 6.83562C8.25176 8.27715 7.21639 9.3275 5.799 9.87099C4.93508 10.1997 4.16771 10.5352 3.45443 10.8989C3.17561 11.0404 3 11.3275 3 11.6404C3 11.9534 3.17561 12.2405 3.45526 12.3828C4.1727 12.7474 4.93924 13.0836 5.7965 13.4082C7.21639 13.9526 8.25093 15.0029 8.78859 16.4428C9.11236 17.3192 9.44277 18.0949 9.79983 18.8181C9.94049 19.1019 10.2293 19.2817 10.5456 19.2817C10.8618 19.2817 11.1515 19.1019 11.2913 18.8181C11.65 18.0949 11.9804 17.3175 12.3017 16.4453C12.8402 15.0037 13.8764 13.9534 15.2921 13.4099C16.1527 13.0836 16.9193 12.7482 17.6367 12.3837C17.9163 12.2414 18.092 11.9551 18.092 11.6413Z" fill="#9B5AF8"/>
<path d="M16.3959 7.45735C16.6082 7.56555 16.8171 7.65461 17.0226 7.73284C17.1949 7.79942 17.3156 7.9226 17.3805 8.09489C17.4571 8.30546 17.5445 8.5152 17.6502 8.72993C17.7892 9.01457 18.0788 9.19601 18.3959 9.19601H18.3976C18.7139 9.19601 19.0035 9.01624 19.1433 8.73242C19.249 8.51853 19.3356 8.30796 19.413 8.09905C19.4796 7.9226 19.6003 7.79942 19.7692 7.73451C19.9781 7.65544 20.1862 7.56638 20.3984 7.45819C20.6781 7.3167 20.8537 7.02872 20.8537 6.71578C20.8537 6.40284 20.6772 6.1157 20.3976 5.97421C20.1862 5.86767 19.9781 5.77862 19.7717 5.69955C19.6003 5.6338 19.4796 5.51062 19.4138 5.33584C19.3356 5.12527 19.249 4.9147 19.1425 4.69997C19.0027 4.41699 18.713 4.23721 18.3968 4.23721H18.3951C18.078 4.23721 17.7892 4.41782 17.6494 4.70246C17.5445 4.91636 17.4571 5.12693 17.3814 5.33334C17.3148 5.50979 17.1941 5.63297 17.0251 5.69789C16.8154 5.77779 16.6073 5.86601 16.3951 5.97421C16.1154 6.1157 15.9398 6.40284 15.9398 6.71578C15.9398 7.02872 16.1154 7.31586 16.3951 7.45735H16.3959Z" fill="#9B5AF8"/>
<path d="M20.8545 16.3154C20.5907 16.1814 20.3302 16.0699 20.0738 15.9734C19.7917 15.8652 19.5861 15.6554 19.4804 15.3708C19.383 15.1078 19.274 14.8448 19.1425 14.5784C19.0018 14.2946 18.7122 14.1149 18.3968 14.1149C18.0797 14.1149 17.79 14.2955 17.651 14.5801C17.5204 14.8464 17.4113 15.1086 17.3164 15.3666C17.2082 15.6554 17.0027 15.8652 16.7247 15.9717C16.465 16.0699 16.2037 16.1814 15.9407 16.3163C15.6618 16.4586 15.4862 16.7449 15.4862 17.0578C15.4862 17.3708 15.6618 17.6571 15.9407 17.7994C16.2037 17.9334 16.4633 18.0441 16.7222 18.1432C17.0027 18.2505 17.2082 18.4594 17.3148 18.7449C17.4113 19.0071 17.5204 19.2701 17.6519 19.5356C17.7917 19.8194 18.0805 19.9992 18.3976 20C18.7139 20 19.0027 19.8211 19.1433 19.5372C19.2757 19.2709 19.3847 19.0079 19.4812 18.7474C19.5878 18.4594 19.7933 18.2505 20.0738 18.1432C20.3335 18.0441 20.5923 17.9343 20.8554 17.8003C21.135 17.6579 21.3106 17.3708 21.3106 17.0578C21.3106 16.7449 21.135 16.4578 20.8554 16.3154H20.8545Z" fill="#9B5AF8"/>`,
  });

  FroalaEditor.RegisterCommand("aiAssistant", {
    title: "AI Assistant",
    icon: "aiAssistantIcon",
    callback: function () {
      setShowAiPrompt((prevState) => !prevState);
      if (setEditorId) {
        // Get the editor ID from the data attribute or generate based on context
        const editorElement = this.el;
        let editorId = 1; // Default

        if (editorElement) {
          // Try to get ID from data attribute first
          const dataId = editorElement.getAttribute("data-editor-id");
          if (dataId) {
            editorId = parseInt(dataId);
          } else {
            // Fallback: determine based on editor content/class
            const parentElement = editorElement.closest(".froalaEditor");
            if (parentElement) {
              if (
                parentElement.classList.contains("froalaEditor--variantTitle")
              ) {
                editorId = 1;
              } else if (
                parentElement.classList.contains(
                  "froalaEditor--variantDescription"
                )
              ) {
                editorId = 3;
              } else {
                editorId = 2; // Default to subtitle for other variants
              }
            }
          }
        }

        setEditorId(editorId, editorElement);
      }
    },
  });
};

// FroalaEditor.DefineIcon('helperGridIcon', {
//   NAME: 'bug',
//   SVG_KEY: 'bug',
//   PATH: 'M20.7854554,12.5746197 C20.9284063,12.7161269 21,12.8838001 21,13.0773263 C21,13.2708916 20.9283669,13.4384475 20.7859676,13.5797983 C20.6436865,13.7212664 20.4747695,13.7920591 20.2797683,13.7920591 L17.7598834,13.7920591 C17.7598834,15.0649595 17.5086947,16.1444509 17.0061205,17.030377 L19.3461347,19.3641514 C19.4882976,19.5055413 19.5597336,19.6730581 19.5597336,19.8666234 C19.5597336,20.0601887 19.4882582,20.2277837 19.3461347,20.3692518 C19.2109065,20.5107199 19.042226,20.5813953 18.8396596,20.5813953 C18.6371326,20.5813953 18.4687278,20.5107199 18.3334603,20.3692518 L16.1058998,18.1694751 C16.0684284,18.2065533 16.0123197,18.2548958 15.9371011,18.3145807 C15.8621582,18.3742656 15.7046678,18.4802983 15.46463,18.6328742 C15.224868,18.7854501 14.9807718,18.9211688 14.7335233,19.0404213 C14.4859597,19.1595565 14.1783472,19.2675448 13.8108041,19.3641905 C13.4433791,19.4611101 13.0797368,19.5095699 12.7198377,19.5095699 L12.7198377,9.50409233 L11.2798077,9.50409233 L11.2798077,19.5095699 C10.8973312,19.5095699 10.5167459,19.4592327 10.1379338,19.3585975 C9.7592792,19.2582361 9.4330295,19.1353462 9.15918464,18.9902406 C8.88553679,18.844744 8.63809136,18.6995211 8.41676955,18.5544155 C8.19540834,18.40931 8.03240169,18.2886494 7.9274344,18.1916907 L7.75859623,18.0350863 L5.69999212,20.3466842 C5.54990938,20.5032887 5.36995981,20.5811607 5.15994641,20.5811607 C4.97995745,20.5811607 4.8188027,20.5214758 4.67628517,20.4023797 C4.53376763,20.2682255 4.45689406,20.102547 4.44570385,19.9055398 C4.43439544,19.7083762 4.49251359,19.5353447 4.62005832,19.3863279 L6.89237963,16.8515178 C6.45745882,16.0030219 6.23988022,14.9828634 6.23988022,13.79202 L3.71999527,13.79202 C3.52499409,13.79202 3.35627413,13.7210708 3.213796,13.5796027 C3.07127847,13.4383693 3,13.270657 3,13.0770916 C3,12.8836827 3.07127847,12.7159705 3.213796,12.5746197 C3.35627413,12.4331515 3.52499409,12.3623588 3.71999527,12.3623588 L6.23988022,12.3623588 L6.23988022,9.07933592 L4.293651,7.14743737 C4.15113347,7.00604746 4.0799338,6.83853073 4.0799338,6.64484806 C4.0799338,6.45136096 4.15113347,6.28384423 4.293651,6.14237609 C4.43616854,6.00098618 4.60484909,5.93023256 4.79996848,5.93023256 C4.99496966,5.93023256 5.16365021,6.00094707 5.30616775,6.14237609 L7.25239696,8.07427464 L16.7469726,8.07427464 L18.6932806,6.14237609 C18.8356799,6.00098618 19.0044787,5.93023256 19.1994799,5.93023256 C19.3944811,5.93023256 19.5632798,6.00094707 19.7056792,6.14237609 C19.8481179,6.28388334 19.919554,6.45136096 19.919554,6.64484806 C19.919554,6.83853073 19.8480785,7.00604746 19.7056792,7.14743737 L17.7593711,9.07933592 L17.7593711,12.3623588 L20.2792561,12.3623588 C20.4742573,12.3623588 20.6433712,12.4331515 20.7854554,12.5746197 Z M14.5186384,4.10083544 C15.2117041,4.83471198 15.5581395,5.72375948 15.5581395,6.76744186 L8.44186047,6.76744186 C8.44186047,5.72359453 8.78833488,4.83471198 9.48140054,4.10083544 C10.174583,3.36704136 11.0139344,3 12.0000389,3 C12.9859877,3 13.8255727,3.36704136 14.5186384,4.10083544 Z'
// });

// FroalaEditor.RegisterCommand('helperGrid', {
//   title: 'Bug inspector',
//   icon: 'helperGridIcon',
//   callback: function () {
//     console.log('Helper Grid clicked!');
//   }
// });

// export const applyHeadingProps = (editor, headingProps) => {
//   if (!editor || !headingProps) return;

//   const { fontColor, fontFamily, fontSize } = headingProps;
//   const frView = editor.el;

//   if (frView) {
//     const h1Elements = frView.querySelectorAll("h1");
//     h1Elements.forEach((h1) => {
//       if (fontColor) h1.style.color = fontColor;
//       if (fontFamily) h1.style.fontFamily = fontFamily;
//       if (fontSize) h1.style.fontSize = `${fontSize}px`;
//     });
//   }
// };

export const applyHeadingProps = (editor, headingProps) => {
  if (!editor || !headingProps) return;

  const frView = editor.el; // the .fr-view element inside the editor
  if (!frView) return;

  const { fontColor, fontFamily, fontSize } = headingProps;

  // Update the CSS variables on the .fr-view element
  frView.style.setProperty("--heading-color", fontColor || "black");
  frView.style.setProperty(
    "--heading-family",
    fontFamily || "Poppins, sans-serif"
  );
  frView.style.setProperty("--heading-size", `${fontSize || 16}px`);
};

export function removeInlineHeadingColors(editor) {
  if (!editor) return;

  // Get the HTML from Froala
  const html = editor?.html?.get();

  // Parse it as a DOM structure
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  // Find all heading tags
  const headings = doc.querySelectorAll("h1, h2, h3, h4, h5, h6");

  headings.forEach((heading) => {
    // For every element inside the heading that has a color style
    heading.querySelectorAll("[style*='color']").forEach((el) => {
      // Either remove the entire style attribute
      // or just remove the color property
      el.style.removeProperty("color");

      // If that was the only style rule, you can remove the style attribute entirely:
      if (el.getAttribute("style")?.trim() === "") {
        el.removeAttribute("style");
      }
    });
  });

  // Put the cleaned HTML back into the editor
  editor?.html?.set(doc.body.innerHTML);
}

export function removeInlineParagraphColors(editor) {
  if (!editor) return;

  // Get the HTML content from the editor
  const html = editor?.html?.get();

  // Parse it into a DOM structure
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  // Find all <p> elements
  const paragraphs = doc.querySelectorAll("p");

  paragraphs.forEach((p) => {
    // For any element inside the paragraph that has a 'color' style
    p.querySelectorAll("[style*='color']").forEach((el) => {
      el.style.removeProperty("color");
      // If that was the only style, remove the attribute entirely
      if (el.getAttribute("style")?.trim() === "") {
        el.removeAttribute("style");
      }
    });
  });

  // Put the cleaned HTML back into Froala
  editor?.html?.set(doc.body.innerHTML);
}

export const applyParagraphProps = (editor, paragraphProps) => {
  if (!editor || !paragraphProps) return;

  const frView = editor.el; // the .fr-view element inside the editor
  if (!frView) return;

  const { fontColor, fontFamily, fontSize } = paragraphProps;

  // Update the CSS variables on the .fr-view element for paragraphs
  frView.style.setProperty("--paragraph-color", fontColor || "black");
  frView.style.setProperty(
    "--paragraph-family",
    fontFamily || "Poppins, sans-serif"
  );
  frView.style.setProperty("--paragraph-size", `${fontSize || 14}px`);
};

export const getCharacterCount = (html) => {
  if (!html) return 0;

  // Create a temporary div to parse the HTML
  const temp = document.createElement("div");
  temp.innerHTML = html;

  // Get the text content (without HTML tags)
  const textContent = temp.textContent || temp.innerText || "";

  return textContent.length;
};
